import type { Theme } from '@mui/material';
export const ADMIN_PROJECTS_TAG = 'ADMIN_PROJECTS';

export const STATUS_ICON_COLOR_MAPPING = (theme: Theme) => {
  return {
    draft: theme.palette.warning.main,
    inProgress: theme.palette.info.main,
    completed: theme.palette.success.main,
    refStdReview: theme.palette.warning.main,
  };
};

export const ADMIN_PROJECT_TABS = {
  OVERVIEW: 'overview',
  ALLOCATION: 'allocation',
} as const;

export type AdminProjectTabType = (typeof ADMIN_PROJECT_TABS)[keyof typeof ADMIN_PROJECT_TABS];
